import { useMemo } from "react";
import { useSelector } from "react-redux";

import { resolveNodeAssociationsSelector } from "@skilitics/nautilus-core-designer-data";

import { getDesignerNodeByIdSelector } from "./contextualSelectors/designerNodeSelectors.ts";
import { populateNodeOnNodeAssociationsCreate } from "./selectors/index.ts";

export const useResolveNodeAssociations = () => {
  const resolveNodeAssociations = useSelector(resolveNodeAssociationsSelector);
  const getById = useSelector(getDesignerNodeByIdSelector);

  return useMemo(
    () => (nodeId: number) => {
      const associations = resolveNodeAssociations(nodeId);
      return populateNodeOnNodeAssociationsCreate(getById)(associations);
    },
    [getById, resolveNodeAssociations],
  );
};
